// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuestionnaireList_wrapper__iBQco"};